export default __webpack_public_path__ + "static/integrations_yotpo-5ec6975d998f981c8f59ecaa2b62db12.png";